import type {EditSupplierContactFormPayload} from "./edit-supplier-contact.schema";
import type {ContactInput} from "@project/sdk/engineering";

import {phoneMapper} from "../../../../../../../support/mappers/phone.mapper";

export const editSupplierContactMapper = {
  toSdk(payload: EditSupplierContactFormPayload): ContactInput {
    const base = {
      name: payload.name,
      ...(payload.description === undefined ? {} : {description: payload.description}),
    };

    if (payload.phone && payload.phonePrefix) {
      return {
        ...base,
        ...(payload.email ? {email: payload.email} : {}),
        phone: phoneMapper.toSdk(payload.phone, payload.phonePrefix),
      };
    }

    if (payload.email) return {...base, email: payload.email};

    throw new Error("Validated contact payload has no communication channel");
  },
};
